/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_HintInputs */

const cs_investor_hint = /** @type {(inputs: Investor_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investiční preference tohoto klienta.`)
};

const en_investor_hint = /** @type {(inputs: Investor_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment preferences for this client.`)
};

/**
* | output |
* | --- |
* | "Investment preferences for this client." |
*
* @param {Investor_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_hint = /** @type {((inputs?: Investor_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_hint(inputs)
	return cs_investor_hint(inputs)
});